import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {SelectItem} from 'primeng/api';

@Component({
    selector: 'dmp-table-schema-edit-label',
    templateUrl: './table-schema-edit-label.component.html',
    styleUrls: ['./table-schema-edit-label.component.scss'],
    standalone: false
})
export class TableSchemaEditLabelComponent implements OnInit {
    i18n: SelectItem[] = [];

    constructor(private config: DynamicDialogConfig) {
        ['FR', 'EN', 'IT'].forEach(code => this.i18n.push({label: code, value: ''}));
    }

    ngOnInit(): void {
        if (this.config.data.labels) {
            const labels = this.config.data.labels;
            ['FR', 'EN', 'IT'].forEach(code => {
                if (labels[code]) {
                    this.i18n.find(i => i.label === code).value = labels[code];
                }
            });
        }

    }

    save() {
        const labels: { [key: string]: string } = {};
        this.i18n.forEach(i => labels[i.label] = i.value);
        this.config.data.save(labels);
    }

    cancel() {
        this.config.data.cancel();
    }
}
